import { ZapOffIcon, LayoutGridIcon, MegaphoneIcon, AccessibilityIcon, MapPinIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Bonus {
  icon: LucideIcon
  title: string
  description: string
  accent: string
}

export const bonuses: Bonus[] = [
  {
    icon: ZapOffIcon,
    title: 'No-Equipment PE',
    description: '50 ready-to-use activities for classes without specialist equipment.',
    accent: 'bg-brand-blue',
  },
  {
    icon: LayoutGridIcon,
    title: 'PE Station Cards',
    description: '40 print-and-go challenges plus ready-made station circuits.',
    accent: 'bg-brand-teal',
  },
  {
    icon: MegaphoneIcon,
    title: 'Class Management Toolkit',
    description: 'Practical routines, signals, transitions, checklists, and teacher scripts.',
    accent: 'bg-brand-orange',
  },
  {
    icon: AccessibilityIcon,
    title: 'Inclusive PE Adaptation Cards',
    description: '36 practical ways to adapt space, equipment, rules, time, communication, and grouping.',
    accent: 'bg-brand-amber',
  },
  {
    icon: MapPinIcon,
    title: 'PE Games for Any Space',
    description: '30 flexible games for gyms, classrooms, playgrounds, and outdoor areas.',
    accent: 'bg-brand-sky',
  },
]
